import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import {
  Form,
  TextArea,
  Button,
  Message,
  Icon,
  Divider
} from "semantic-ui-react";
import TextBlock from "../text/TextBlock";
import TextParagraph from "../../../../../components/ui/TextParagraph";

/**
 * QuestionBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block for a simple quiz question
 *
 * @param {*} props
 */
class QuestionBlock extends Component {
  state = {
    currentAnswer: "",

    isDirty: false,
    isCorrect: false
  };

  checkSolution = () => {
    const correct =
      this.props.block.answer.toLowerCase().trim() ===
      this.state.currentAnswer.toLowerCase().trim();

    this.setState({
      isDirty: true,
      isCorrect: correct
    });
  };

  render() {
    return this.props.isReadOnlyMode ? (
      <div className="ed-question">
        <Form className="ed-question-form">
          <TextParagraph content={this.props.block.question} />
          <TextArea
            value={this.state.currentAnswer}
            onChange={(_, { value }) => {
              this.setState({ currentAnswer: value });
            }}
            placeholder={this.props.intl.formatMessage({
              id: "manuscript.blocks.quiz.answer"
            })}
          />
          {!this.state.isCorrect ? (
            <Button color="blue" compact onClick={() => this.checkSolution()}>
              <FormattedMessage
                id="manuscript.blocks.quiz.checkAnswer"
                description="Button to check the answer"
              />
            </Button>
          ) : null}
        </Form>
        {this.state.isDirty ? (
          <Message
            warning={!this.state.isCorrect}
            positive={this.state.isCorrect}
          >
            <Icon name={this.state.isCorrect ? "checkmark" : "warning"} />
            {this.state.isCorrect ? (
              <FormattedMessage
                id="manuscript.blocks.quiz.correctAnswer"
                description="Info text displayed when the correct answer was entered"
              />
            ) : (
              <FormattedMessage
                id="manuscript.blocks.quiz.wrongAnswer"
                description="Info text displayed when the correct answer was entered"
                values={{ correctAnswer: this.props.block.answer }}
              />
            )}
          </Message>
        ) : null}
      </div>
    ) : (
      <div>
        <TextBlock
          {...this.props}
          dataKey={"question"}
          placeholder={"manuscript.blocks.quiz.placeholder"}
        />
        <Divider />
        <TextBlock
          {...this.props}
          dataKey={"answer"}
          placeholder={"manuscript.blocks.quiz.answer"}
        />
      </div>
    );
  }
}

QuestionBlock.propTypes = {
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    answer: PropTypes.string,
    question: PropTypes.string
  }).isRequired,

  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired
};

export default injectIntl(QuestionBlock);



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/quiz/QuestionBlock.js